/* eslint-disable no-plusplus */
function get(amountTotal, products) {
  if (amountTotal < 1) {
    return [
      ...products.filter(
        product =>
          product.product_id !== products[products.length - 1].product_id
      ),
      {
        ...products[products.length - 1],
        amount: parseFloat(
          (products[products.length - 1].amount + (1 - amountTotal)).toFixed(3)
        ),
      },
    ];
  }

  return [...products];
}

const make = (items, categories) => {
  const result = [];
  items.map(item => {
    const category = categories.find(f => f.category_id === item.category_id);
    if (category.pizza === 'S') {
      const complements = [];
      item.complements
        .filter(f => f.selected >= 1)
        .map(complement => {
          if (complement.required === 'S') {
            const key = new Date().getTime();
            const amountDefault = parseFloat((1 / complement.max).toFixed(3));
            const biggestPrice = complement.items
              .filter(f => f.amount >= 1)
              .reduce((a, b) => {
                return a < b.price ? b.price : a;
              }, 0);

            const products = complement.items
              .filter(f => f.amount >= 1)
              .sort((a, b) => {
                return a.amount > b.amount ? -1 : 1;
              })
              .map(product => {
                return {
                  ...product,
                  price: biggestPrice,
                  amount: amountDefault * product.amount,
                };
              });

            const amountTotal = parseFloat(
              products
                .reduce((a, product) => {
                  return a + product.amount;
                }, 0)
                .toFixed(3)
            );

            complements.push({
              key,
              name: complement.name,
              price: biggestPrice,
              items: get(amountTotal, products).map(product => {
                return {
                  product_id: product.product_id,
                  price: product.price,
                  amount: product.amount,
                  comment: null,
                  key: null,
                };
              }),
            });
          } else {
            const products = complement.items
              .filter(f => f.amount >= 1)
              .map(product => {
                return {
                  product_id: product.product_id,
                  price: product.price,
                  amount: product.amount,
                  comment: null,
                  key: null,
                };
              });

            complements.push({
              name: complement.name,
              items: products.map(product => {
                return {
                  product_id: product.product_id,
                  price: product.price,
                  amount: product.amount,
                  comment: null,
                  key: null,
                };
              }),
            });
          }

          return null;
        });

      const sumaTotal = complements
        .filter(f => f.key)
        .reduce((a, b) => {
          return a + b.price;
        }, 0);

      for (let i = 1; i <= item.amount; i++) {
        const key = new Date().getTime();
        complements.map(complement => {
          if (complement.key) {
            const percentagem = (complement.price * 100) / sumaTotal;
            const price = (item.price * percentagem) / 100;

            complement.items.map(product => {
              result.push({
                product_id: product.product_id,
                price,
                amount: product.amount,
                comment: null,
                key,
              });

              return null;
            });
          } else {
            complement.items.map(product => {
              result.push({ ...product });

              return null;
            });
          }

          return null;
        });

        if (item.comment && item.comment.trim().length >= 1) {
          result[result.length - 1].comment = item.comment.trim();
        }
      }
    } else {
      result.push({
        product_id: item.product_id,
        price: item.price,
        amount: item.amount,
        comment: item.comment,
        key: null,
      });

      item.complements
        .filter(f => f.required === 'S')
        .map(complement => {
          complement.items
            .filter(f => f.amount >= 1)
            .map(product => {
              const { comment } = result[result.length - 1];

              result[result.length - 1].comment = comment
                ? `${comment.trim()}\n${product.name}`
                : `${product.name}`;

              return null;
            });

          return null;
        });

      item.complements
        .filter(f => f.required === 'N' && f.selected >= 1)
        .map(complement => {
          complement.items
            .filter(f => f.amount >= 1)
            .map(product => {
              result.push({
                product_id: product.product_id,
                price: product.price,
                amount: product.amount,
                comment: null,
                key: null,
              });

              return null;
            });

          return null;
        });
    }

    return null;
  });

  return result;
};

export default make;
